export default __webpack_public_path__ + "static/media/avatar-2.869ee6d7.png";